var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"list-counter mt-3 mb-5"},_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"text-xl mb-6"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }